import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { Validator } from "@redotech/ui/validator";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Text } from "../../../../text";

const customerIdGuidValidator: Validator<{
  customerId: string;
  customerGuid: string;
}> = (value) => {
  const hasCustomerId = value.customerId && value.customerId.trim() !== "";
  const hasCustomerGuid =
    value.customerGuid && value.customerGuid.trim() !== "";

  if (hasCustomerId !== hasCustomerGuid) {
    return [
      "Both customer ID and customer GUID must be provided together, or neither should be provided",
    ];
  }

  return [];
};

export const UpsMailInnovationsCarrierInput = groupInput(
  {
    accountNumber: input<string>({ validator: nonEmptyValidator }),
    userId: input<string>({ validator: nonEmptyValidator }),
    password: input<string>({ validator: nonEmptyValidator }),
    customerId: input<string>(),
    customerGuid: input<string>(),
  },
  { validator: customerIdGuidValidator },
);

export type UpsMailInnovationsCarrierValue = InputSchema.Value<
  typeof UpsMailInnovationsCarrierInput
>;

export type UpsMailInnovationsCarrierForm = InputSchema.Input<
  typeof UpsMailInnovationsCarrierInput
>;

export const upsMailInnovationsCarrierDefault =
  (): UpsMailInnovationsCarrierValue => ({
    accountNumber: "",
    userId: "",
    password: "",
    customerId: "",
    customerGuid: "",
  });

export const CreateUpsMailInnovationsCarrierForm = memo(
  function CreateUpsMailInnovationsCarrierForm({
    carrierInput,
  }: {
    carrierInput: UpsMailInnovationsCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="UPS Shipper Number"
          placeholder="Enter UPS shipper number"
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="UPS.com User ID"
          placeholder="Enter UPS.com user ID"
          setValue={carrierInput.inputs.userId.setValue}
          value={carrierInput.inputs.userId.value}
        />
        <RedoTextInput
          label="UPS.com Password"
          placeholder="Enter UPS.com password"
          setValue={carrierInput.inputs.password.setValue}
          value={carrierInput.inputs.password.value}
        />
        <Text fontSize="xs" textColor="primary">
          If you do not provide a customer ID and customer GUID, you will need
          to provide your rate table file before you can fetch rates with this
          account. Please contact Redo Support for details.
        </Text>
        <RedoTextInput
          label="UPS customer id (optional)"
          placeholder="Enter UPS customer ID (optional)"
          setValue={carrierInput.inputs.customerId.setValue}
          value={carrierInput.inputs.customerId.value}
        />
        <RedoTextInput
          label="UPS customer GUID (optional)"
          placeholder="Enter UPS customer GUID (optional)"
          setValue={carrierInput.inputs.customerGuid.setValue}
          value={carrierInput.inputs.customerGuid.value}
        />
      </>
    );
  },
);
